module.exports = __webpack_public_path__ + "img/pr-2.dcd3531c.png";